import React from 'react';

interface SvgIconProps {
  isActive: boolean;
  opacity?: number;
}

export const ApprovalsIcon = ({
  isActive,
  opacity = 1.0,
  ...props
}: SvgIconProps) => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 7L5 9L11 3"
        stroke={isActive ? "#fff" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={opacity}
      />
      <circle
        cx="7"
        cy="7"
        r="6"
        stroke={isActive ? "#fff" : "#214160"}
        strokeWidth={2}
        opacity={opacity}
      />
    </svg>
  );
};
